import { Component, Injector, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractComponent } from '../abstract.component';
import { PaymentPromosModel } from './payment-promos-model';
import { Module } from 'projects/common/model/ModuleModel';
import { ModulesFilterService } from 'projects/common/services/modules-filter.service';
import { Subscription } from 'rxjs';
import { FaqsService } from 'projects/common/services/faqs.service';

@Component({
  selector: 'payment-promos',
  template: `
    <text *ngIf="module.pretitle || module.title || module.subtitle" [data]="module" class="-eva-3-mb-xlg"></text>
    <div class="payment-promos-container">
      <div class="cards-grid">
        <ng-container *ngFor="let promo of filteredPromos">
          <payment-promo-card 
            (focusBanner)="focusBanner($event)" 
            [promoData]="promo">
          </payment-promo-card>
        </ng-container>
      </div>

      <div *ngIf="!module.filterable" class="banners-column eva-3-card">
        <ng-container *ngFor="let promo of module.data.promos; let last = last">
          <payment-promo-banner [promoData]="promo"></payment-promo-banner>
          <div *ngIf="!last" class="banner-separator"></div>
        </ng-container>
      </div>
    </div>
  `,
  styleUrls: ['./payment-promos.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PaymentPromosComponent extends AbstractComponent implements OnInit, OnDestroy {
  @Input() moduleId: string;
  @Input() override module: Module<PaymentPromosModel>;

  filteredPromos: any[] = [];
  private modulesSubscription: Subscription;

  constructor(
    injector: Injector,
    private modulesFilterService: ModulesFilterService,
    private faqsService: FaqsService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.modulesSubscription = this.modulesFilterService.modules$.subscribe((modules) => {
      const paymentPromosModule = modules.find((module) => module.id === this.module.id);
      this.filteredPromos = this.module.filterable ? paymentPromosModule?.data?.promos || [] : this.module.data.promos;
    });
  }

  ngOnDestroy(): void {
    if (this.modulesSubscription) {
      this.modulesSubscription.unsubscribe();
    }
  }

  focusBanner(bannerId: string): void {
    this.faqsService.closeAllFaqs();
    // Timeout 0 para asegurar que el dom esté actualizado antes de calcular la posición del scroll 
    setTimeout(() => {
      document.getElementById(bannerId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.faqsService.openFaqById(bannerId);
    }, 0);
  }

  getModuleId(): string {
    return this.moduleId;
  }
}
